<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ConsigneeShipperAndNotifyAddress')"
    width="1000px"
    :close-on-click-modal="false"
    append-to-body
    class="app-main-inner"
  >
    <el-form label-width="120px" label-position="left" style="width: 100%;margin-bottom: 5px">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
            <cargo-company-select
              v-if="fba"
              no="customerId"
              class="shipper-selector"
              popper-class="shipper-selector-popper"
              :method-params="{customer:true, active:true, fba:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.customerId||''"
              :static-options="customerCmpList"
              style="flex: 1;"
              :data-filter-function="customerIdFilter"
              @change="p=>{filter.partnerId=p.value}"
            />
            <cargo-company-select
              v-else
              :method-params="{customer:true}"
              :default-value="filter.partnerId||''"
              no="1"
              @change="p=>{filter.partnerId=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_Destination')">
            <el-cascader
              v-model="filter.warehouseCode"
              :options="destinations"
              filterable
              style="width: 200px"
              :clearable="true"
              no="2"
              @focus="JobUtils.focusWarehouseCode(filter)"
              @blur="JobUtils.blurWarehouseCode(filter)"
              @change="p=>{JobUtils.warehouseCodeHandler(filter, p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button type="primary" no="3" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
          <el-button type="primary" no="4" @click="reset">{{ $t('CargoMsg.Cargo_Empty') }}</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ShipperSName')">
            <el-input v-model="filter.shipperEnterpriseName" no="5" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_ConsigneeSName')">
            <el-input v-model="filter.consigneeEnterpriseName" no="6" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('CargoMsg.Cargo_NotifyPartySName')">
            <el-input v-model="filter.notifyEnterpriseName" no="7" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>{gridApi=params.api}"
    />
    <span slot="footer">
      <el-button
        type="primary"
        no="8"
        @click="choose(['shipperInfo'])"
      >{{ $t('SeaExport.CopyShipper') }}</el-button>
      <el-button
        type="primary"
        no="9"
        @click="choose(['consigneeInfo'])"
      >{{ $t('SeaExport.CopyConsignee') }}</el-button>
      <el-button
        type="primary"
        no="10"
        @click="choose(['notifyInfo'])"
      >{{ $t('SeaExport.CopyNotify') }}</el-button>
      <el-button
        type="primary"
        no="11"
        @click="choose(['shipperInfo','consigneeInfo','notifyInfo'])"
      >{{ $t('CargoMsg.Cargo_Select') }}</el-button>
      <el-button no="12" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getMailingAddressList } from '@/api/partner/fbaMailingAddress'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'BillAddressDialog',
  components: { cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, default: null },
    customerCmpList: { type: Object, default: null },
    fba: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      filter: {
        lob: 'SE',
        partnerId: '',
        warehouseCode: '',
        shipperEnterpriseName: '',
        consigneeEnterpriseName: '',
        notifyEnterpriseName: '',
        officeId: ''
      },
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        rowHeight: 150,
        context: {
          componentParent: this
        },
        onRowClicked: this.selectItemClickHandler,
        onRowSelected: this.selectItemClickHandler
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('SeaExport.Shipper') + this.$t('SeaExport.CompanyName'), width: 150,
          field: 'shipperEnterpriseName',
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('SeaExport.Consignee') + this.$t('SeaExport.CompanyName'), width: 150,
          field: 'consigneeEnterpriseName',
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('SeaExport.NotifyParty') + this.$t('SeaExport.CompanyName'), width: 150,
          field: 'notifyEnterpriseName',
          tooltipValueGetter: (params) => {
            return params.value
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.shipperInfo'), width: 150,
          field: 'shipperInfo',
          cellRenderer: (params) => {
            return this.multipleDataRellRenderer(params, 'shipper')
          },
          tooltipValueGetter: (params) => {
            return this.multipleDataRellRenderer(params, 'shipper')
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.consigneeInfo'), width: 150,
          field: 'consigneeInfo',
          cellRenderer: (params) => {
            return this.multipleDataRellRenderer(params, 'consignee')
          },
          tooltipValueGetter: (params) => {
            return this.multipleDataRellRenderer(params, 'consignee')
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.notifyInfo'), width: 150,
          field: 'notifyInfo',
          cellRenderer: (params) => {
            return this.multipleDataRellRenderer(params, 'notify')
          },
          tooltipValueGetter: (params) => {
            return this.multipleDataRellRenderer(params, 'notify')
          }
        }
      ],
      selectItem: null,
      rowData: [],
      gridApi: null
    }
  },
  computed: {
    JobUtils() {
      return JobUtils
    },
    destinations() { // 目的地 可选项
      return JobUtils.initDestination()
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
      this.selectItem = null
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
      this.toQuery()
    }
  },
  methods: {
    init() {
      if (!this.innerVisible) {
        return
      }
      this.filter.partnerId = ''
      this.filter.warehouseCode = ''
      this.filter.shipperEnterpriseName = ''
      this.filter.consigneeEnterpriseName = ''
      this.filter.notifyEnterpriseName = ''
      this.filter.officeId = ''
      if (this.job) {
        this.filter.lob = this.job.shippingType
        this.filter.partnerId = this.job.customerId
        this.filter.warehouseCode = this.job.warehouseCode
      }
      this.toQuery()
    },
    selectItemClickHandler(event) {
      if (!event.data) {
        return
      }
      this.selectItem = event.data
    },
    reset() {
      if (!this.filter) return
      for (const key in this.filter) {
        this.filter[key] = ''
      }
    },
    toQuery() {
      if (!this.filter.partnerId || Number(this.filter.partnerId) <= 0) {
        this.$message.warning('请先选择委托单位。')
        return
      }
      const loading = getLoading4Cxt(this)
      this.filter.officeId = this.$store.getters.currentOfficeId
      getMailingAddressList(this.filter).then(res => {
        this.rowData = res.data.list
      }).finally(() => {
        this.selectItem = null
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
        loading.close()
      })
    },
    customerIdFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customer && item.fba && item.active
    },
    multipleDataRellRenderer(params, handleType) {
      const addr = params.data
      let curInfo = ''
      switch (handleType) {
        case 'shipper':
          if (addr.shipperEnterpriseName) {
            curInfo += addr.shipperEnterpriseName
          }
          if (addr.shipperAddress1) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.shipperAddress1
          }
          addr.shipperLine3 = (addr.shipperCityCode +
            addr.shipperProvinceCode +
            addr.shipperCountryCode +
            addr.shipperZipCode)
          if (addr.shipperLine3) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.shipperLine3
          }
          if (addr.notifyContactTel) {
            if (curInfo) curInfo += '<br/>'
            curInfo += ('TEL:' + addr.shipperContactTel)
          }
          break
        case 'consignee':
          if (addr.consigneeEnterpriseName) {
            curInfo += addr.consigneeEnterpriseName
          }
          if (addr.consigneeAddress1) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.consigneeAddress1
          }
          addr.consigneeLine3 = (addr.consigneeCityCode +
            addr.consigneeProvinceCode +
            addr.consigneeCountryCode +
            addr.consigneeZipCode)
          if (addr.consigneeLine3) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.consigneeLine3
          }
          if (addr.consigneeContactTel) {
            if (curInfo) curInfo += '<br/>'
            curInfo += ('TEL:' + addr.consigneeContactTel)
          }
          break
        case 'notify':
          if (addr.notifyEnterpriseName) {
            curInfo += addr.notifyEnterpriseName
          }
          if (addr.notifyAddress1) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.notifyAddress1
          }
          addr.notifyLine3 = (addr.notifyCityCode +
            addr.notifyProvinceCode +
            addr.notifyCountryCode +
            addr.notifyZipCode)
          if (addr.notifyLine3) {
            if (curInfo) curInfo += '<br/>'
            curInfo += addr.notifyLine3
          }
          if (addr.notifyContactTel) {
            if (curInfo) curInfo += '<br/>'
            curInfo += ('TEL:' + addr.notifyContactTel)
          }
          break
        default:
          break
      }
      return curInfo
    },
    choose(fieldKeys) {
      if (!this.selectItem) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const data = {}
      for (const key of fieldKeys) {
        data[key] = this.selectItem
      }
      this.$emit('callback', data)
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
